import React from 'react';
import './TooltipItem.css';

//const imagensPoliticos = {
//    Manaus: require.context('./img/politicos-2016', true)
//};

class TooltipItem extends React.Component {

    render () {
        const politico = this.props.politico;
        const periodo = this.props.periodo;

        const popularidadePercentual = (politico.popularidade === 0 ? 0 : Math.round(politico.popularidade / periodo.total * 100));

        const tamColunaPositivo = Math.min(8,Math.max(2,Math.round(politico.percentPositivo / (100/12))));
        const tamColunaNeutro = Math.min(9,Math.max(3,Math.floor(politico.percentNeutro / (100/12))));
        const tamColunaNegativo = 12 - tamColunaPositivo - tamColunaNeutro;

        return (
            <li className="list-group-item tooltip-item">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-4 tooltip-img">
                            <img alt={politico.nome}
//                                 src={imagensPoliticos.Manaus("./"+this.props.cidade + '/' +politico.imagem, true)}
                                 src={encodeURIComponent("img/politicos-2016/" + this.props.cidade + '/' + politico.imagem)}
                                 className="rounded_image img-fluid" style={{width: "50px"}}/>
                        </div>
                        <div className="col-8 tooltip-body">
                            <div className="tp-nome">{politico.nome}</div>
                            <div className="tooltip-percentual">
                                <div className="tooltip-pop-label">Popularidade: </div>
                                <div className="tooltip-pop-perc">{popularidadePercentual}%</div>
                            </div>
                            <div className="tooltip-legenda">
                                <span className="tooltip-pop-value">{politico.popularidade}</span> de <span className="tooltip-pop-value">{periodo.total}</span> tweets
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-" + tamColunaNegativo +  " tooltip-progress tp-label-progress tp-neg"}>
                            {politico.percentNegativo}%
                        </div>
                        <div className={"col-" + tamColunaNeutro +  " tooltip-progress tp-label-progress tp-neutro"}>
                            {politico.percentNeutro}%
                        </div>
                        <div className={"col-" + tamColunaPositivo +  " tooltip-progress tp-label-progress tp-pos"}>
                            {politico.percentPositivo}%
                        </div>
                    </div>
                    <div className="row">
                        <div className="col" style={{padding: 0}}>
                            <div className="progress">
                                <div className="progress-bar bg-danger" role="progressbar" style={{width: politico.percentNegativo + "%"}}>
                                </div>
                                <div className="progress-bar bg-gray" role="progressbar" style={{width: politico.percentNeutro + "%"}}>
                                </div>
                                <div className="progress-bar bg-success" role="progressbar" style={{width: politico.percentPositivo + "%"}}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default TooltipItem;


// WEBPACK FOOTER //
// ./src/scenes/Home/components/GraficoSentimento/TooltipItem.js